import { Component, OnInit } from "@angular/core";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import {
  CardValidationService,
  CardValidationDetails,
} from "./../../services/card-validation.service";
import { CountryService, Country } from "./../../services/country.service";
import {
  ExistingEmailResponse,
  EmailService,
} from "./../../services/email.service";
import { PasswordService } from "src/app/services/password.service";
import { SpinnerService } from "../spinner/spinner.service";
import { NewUser, UserService } from "src/app/services/user.service";
//import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SelectItem } from "primeng/components/common/selectitem";
import { Subscription } from "rxjs";

const Patterns = {
  email: /^(\S+)@(\S+)\.(\S{2})/,
  phone: {
    mask: [
      "(",
      /\d/,
      /\d/,
      /\d/,
      ")",
      " ",
      /\d/,
      /\d/,
      /\d/,
      "-",
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    pattern: /\(\d{3}\)\s\d{3}-\d{4}/,
  },
  postalCode: {
    mask: {
      usa: "00000-0000",
      canada: "S0S 0S0",
    },
    pattern: {
      usa: /^\d{5}(-\d{4})?$/,
      canada: /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/,
    },
  },
};

const Countries = [
  { value: "1", label: "United States" },
  { value: "2", label: "Canada" },
];

@Component({
  selector: "gca-registration",
  templateUrl: "./registration.component.html",
  styleUrls: ["./registration.component.scss"],
})
export class RegistrationComponent implements OnInit {
  isLoginSub: Subscription;

  acceptTermsAndConditions: boolean;
  cardValidationDetails: CardValidationDetails;
  cardDetailsWasPassedInUrl: boolean;
  country: Country;
  createPasswordError: string;
  emailWasSent = false;
  errorMessage: string;
  existingEmail: boolean = false;
  form: FormGroup;
  phoneMask: (string | RegExp)[] = Patterns.phone.mask;
  postalCodeMask: string;
  submitted = false;
  countries: Country[];
  countriesOptions: SelectItem[] = Countries;

  constructor(
    private cardValidationService: CardValidationService,
    private countryService: CountryService,
    // private googleAnalyticsService: GoogleAnalyticsService,
    private emailService: EmailService,
    private fb: FormBuilder,
    private passworsService: PasswordService,
    private router: Router,
    private spinnerService: SpinnerService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.cardDetailsWasPassedInUrl = JSON.parse(
      localStorage.getItem("cardDetailsWasPassedInUrl")
    );
    this.cardValidationDetails =
      this.cardValidationService.cardValidationDetails;

    if (this.cardValidationDetails) {
      this.getCountriesAndStates();
    } else {
      this.router.navigate(["/card-activation"]);
    }

    this.isLoginSub = this.userService.loginChanged$.subscribe((res) => {
      if (this.userService.isLoggedIn) {
        this.router.navigateByUrl(
          `/card-activation${localStorage.getItem("cardDetailsUrl")}`
        );
      }
    });
  }

  checkExistingEmail(email: string): void {
    this.emailService.checkExistingEmail(email).subscribe((res: any[]) => {
      this.existingEmail = res && res.length > 0;
    });
  }

  onSubmit(): void {
    this.submitted = true;

    if (
      this.form.valid &&
      !this.existingEmail &&
      this.acceptTermsAndConditions
    ) {
      this.spinnerService.showSpinner({
        text: "Registration being processed…",
      });
      const body = { ...this.form.value };
      body.shipAddress.countryId = this.country.value;
      body.sourceId = localStorage.getItem("sourceId")
        ? localStorage.getItem("sourceId")
        : null;

      delete body.confirmPassword;
      console.log(body);
      let newUser: NewUser = {
        contactInfo: {
          firstName: body.firstName,
          lastName: body.lastName,
          email: body.email,
          phone: body.phone,
        },
        referralId: null,
        password: body.password,
        shippingAddress: {
          addressName: body.shipAddress.fullName,
          address1: body.shipAddress.address1,
          address2: body.shipAddress.address2,
          city: body.shipAddress.city,
          state: body.shipAddress.state,
          postalCode: body.shipAddress.postalCode,
          countryId: body.shipAddress.countryId,
          isDefaultBillingAddress: true,
          isDefaultShippingAddress: true,
        },
        billingAddress: {
          addressName: body.shipAddress.fullName,
          address1: body.shipAddress.address1,
          address2: body.shipAddress.address2,
          city: body.shipAddress.city,
          state: body.shipAddress.state,
          postalCode: body.shipAddress.postalCode,
          countryId: body.shipAddress.countryId,
          isDefaultBillingAddress: true,
          isDefaultShippingAddress: true,
        },
      };

      console.log(newUser);

      this.userService.createNewUser(newUser).subscribe(
        (res) => {
          console.log(res);
          this.spinnerService.hideSpinner();
          this.cardValidationService.memberId = res;
          this.login();
        },
        (error) => {
          this.spinnerService.hideSpinner();
          this.errorMessage = error.Message
            ? error.Message
            : "Something went wrong...";
        }
      );
    }
  }

  setPhonePatternValidator(controlName: string): void {
    this.form.controls[controlName].setValidators(
      Validators.pattern(Patterns.phone.pattern)
    );
  }

  showError(controlName: string, formGroupName?: string): boolean {
    if (formGroupName) {
      return (
        ((<FormGroup>this.form.controls[formGroupName]).controls[controlName]
          .invalid &&
          (<FormGroup>this.form.controls[formGroupName]).controls[controlName]
            .dirty) ||
        ((<FormGroup>this.form.controls[formGroupName]).controls[controlName]
          .invalid &&
          this.submitted)
      );
    } else {
      return (
        (this.form.controls[controlName].invalid &&
          this.form.controls[controlName].dirty) ||
        (this.form.controls[controlName].invalid && this.submitted)
      );
    }
  }

  changeCountry(countryId): void {
    this.country = this.countries.filter(
      (country) => country.value === +countryId
    )[0];
    (<FormGroup>this.form.controls.shipAddress).controls.postalCode.setValue(
      null
    );
    (<FormGroup>(
      this.form.controls.shipAddress
    )).controls.postalCode.setValidators([
      Validators.required,
      Validators.pattern(this.getPatternForPostalCode()),
    ]);
    this.postalCodeMask =
      this.country.value === 2
        ? Patterns.postalCode.mask.canada
        : Patterns.postalCode.mask.usa;
  }

  private buildForm() {
    this.form = this.fb.group(
      {
        firstName: ["", Validators.required],
        lastName: ["", Validators.required],
        email: ["", [Validators.required, Validators.pattern(Patterns.email)]],
        phone: ["", Validators.required],
        referralId: [
          this.cardValidationDetails.EnrollerID,
          Validators.required,
        ],
        shipAddress: this.fb.group({
          fullName: ["", Validators.required],
          address1: ["", Validators.required],
          address2: [""],
          city: ["", Validators.required],
          state: ["", Validators.required],
          postalCode: [
            "",
            [
              Validators.required,
              Validators.pattern(this.getPatternForPostalCode()),
            ],
          ],
          countryId: [this.country.label, Validators.required],
        }),
        password: [
          "",
          [
            Validators.required,
            Validators.maxLength(11),
            Validators.minLength(6),
            Validators.pattern(/^[a-zA-Z0-9]*$/),
          ],
        ],
        confirmPassword: ["", Validators.required],
      },
      { validator: this.equalPasswords("password", "confirmPassword") }
    );
  }

  private equalPasswords(
    passwordName: string,
    confirmPasswordName: string
  ): Function {
    return (group: FormGroup): { [key: string]: any } => {
      const password = group.controls[passwordName];
      const confirmPassword = group.controls[confirmPasswordName];

      if (password.value !== confirmPassword.value) {
        return {
          equalPasswords: true,
        };
      }
    };
  }

  private getCountriesAndStates(): void {
    this.spinnerService.showSpinner({ text: "Validating gift card…" });
    this.countryService.getCountriesWithStates().subscribe(
      (countries: Country[]) => {
        this.spinnerService.hideSpinner();
        this.countries = countries;
        this.country = countries.filter((country) => country.value === 1)[0];

        // define mask for postalCode field
        this.postalCodeMask =
          this.country.value === 2
            ? Patterns.postalCode.mask.canada
            : Patterns.postalCode.mask.usa;
        this.buildForm();
      },
      (error) => {
        this.spinnerService.hideSpinner();
        this.errorMessage = error.Message
          ? error.Message
          : "Something went wrong...";
      }
    );
  }

  private getPatternForPostalCode(): RegExp {
    return this.country.value === 2
      ? Patterns.postalCode.pattern.canada
      : Patterns.postalCode.pattern.usa;
  }

  login() {
    this.userService.openLoginModal(
      location.origin +
        "/card-activation/" +
        localStorage.getItem("cardDetailsUrl")
    );
  }

  ngOnDestroy() {
    this.isLoginSub.unsubscribe();
  }
}
